import { useState, useEffect } from "react";
import { Table, Pagination, Checkbox } from "antd";
import { ChevronRight } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { getClientMemberListApi } from "../../../../redux/action/Client-Member";
import { useNavigate } from "react-router-dom";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { riskStatusBadge, statusBadge } from "./MemberTableConfig";
import useIsMobile from "../shared/Mobile-Responsive";
import "./index.css";

const MembersTable = ({ searchTerm, sortConfig,onSelectedRowsChange,setExportData,setVisibleData,selectedRows   }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
 const isMobile = useIsMobile();
  // For client-side pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageDropdownOpen, setPageDropdownOpen] = useState(false);
  const [selectedPageSize, setSelectedPageSize] = useState(pageSize);
  // const [selectedRows, setSelectedRows] = useState([]);

 
  const pageSizeOptions = [10, 20, 50, 100];

  // Get full list from redux store (fetched once)
  const { clientMemberList, clientMemberListLoading } = useSelector(
    (state) => state.CLIENT_MEMBER
  );

  // Fetch all data once on mount
  useEffect(() => {
    dispatch(
      getClientMemberListApi({
        page: 0,
        size: 5000, // fetch all records
      })
    );
  }, [dispatch]);

  // Format the data
  const formattedData = Array.isArray(clientMemberList)
    ? clientMemberList.map((item, index) => ({
        key: item.pcUserId || index,
        name: item.name || item.firstName || "NA",
        email: item.email || "NA",
        gender: item.gender?.toUpperCase() || "NA",
        age: item.age || "NA",
        joinedSince: item?.joinedSince || "N/A",
        riskStatus: item.riskStatus?.toUpperCase() || "NA",
        lastAppointment: item.lastAppointment || "N/A",
        status: item.status?.toUpperCase() || "N/A",
        mobile: item.mobileNo || "NA",
      }))
    : [];

  // Search (client-side)
  const searchedData = searchTerm
    ? formattedData.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    : formattedData;

  // Sort (client-side)
  const sortedData = [...searchedData].sort((a, b) => {
    if (!sortConfig?.field) return 0;
    const field = sortConfig.field;

    let valA = a[field];
    let valB = b[field];

    if (field === "joinedSince" || field === "lastAppointment") {
      valA = new Date(valA).getTime() || 0;
      valB = new Date(valB).getTime() || 0;
    } else {
      valA = valA?.toString().toLowerCase() || "";
      valB = valB?.toString().toLowerCase() || "";
    }

    return sortConfig.order === "asc"
      ? valA > valB
        ? 1
        : valA < valB
        ? -1
        : 0
      : valB > valA
      ? 1
      : valB < valA
      ? -1
      : 0;
  });

  // Paginate the sorted data client-side
  const paginatedData = sortedData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Handle row selection
  // const handleRowSelection = (selectedRowKeys) => {
  //   setSelectedRows(selectedRowKeys);
  //   onSelectedRowsChange(selectedRowKeys);
  // };
  useEffect(() => {
    if (setExportData) {
      setExportData((prevData) => {
        // Compare stringified versions to avoid unnecessary updates
        if (JSON.stringify(prevData) !== JSON.stringify(sortedData)) {
          return sortedData;
        }
        return prevData; // No change → no re-render loop
      });
    }
  }, [sortedData, setExportData]);

  useEffect(() => {
    if (setVisibleData) {
      setVisibleData((prevData) => {
        // Compare stringified versions to avoid unnecessary updates
        if (JSON.stringify(prevData) !== JSON.stringify(paginatedData)) {
          return paginatedData;
        }
        return prevData; // No change → no re-render loop
      });
    }
  }, [paginatedData, setVisibleData]);


  // Handle single row checkbox
// const handleSingleRowSelect = (recordKey) => {
//   setSelectedRows(prev => {
//     const newSelection = prev.includes(recordKey)
//       ? prev.filter(key => key !== recordKey)
//       : [...prev, recordKey];
    
//     onSelectedRowsChange && onSelectedRowsChange(newSelection);  // ADD THIS LINE
//     return newSelection;
//   });
// };

const handleSingleRowSelect = (recordKey) => {
   const newSelection = selectedRows.includes(recordKey)
     ? selectedRows.filter(key => key !== recordKey)
     : [...selectedRows, recordKey];
   onSelectedRowsChange(newSelection);
 };


 const handleRowSelection = (selectedRowKeys) => {
   onSelectedRowsChange(selectedRowKeys);
 };


  // Mobile Card Component
  const MemberCard = ({ member }) => (
    <div className="bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm px-4 py-3 mb-3 font-poppins">

  <div className="flex items-end justify-end mb-2">
    <Checkbox
              checked={selectedRows.includes(member.key)}
              onChange={() => handleSingleRowSelect(member.key)}
              className="flex-shrink-0"
            />
</div>

     
 <div className="flex justify-between">
  
 </div>
      <div className="space-y-3">
        <div className="flex justify-between">
          <span className="text-[11px] font-semibold text-[#64748B] uppercase tracking-wide">NAME</span>
          <span className="text-[13px] font-medium text-[#171717]">{member.name}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-[11px] font-semibold text-[#64748B] uppercase tracking-wide">AGE</span>
          <span className="text-[13px] font-medium text-[#171717]">{member.age}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-[11px] font-semibold text-[#64748B] uppercase tracking-wide">GENDER</span>
          <span className="text-[13px] font-medium text-[#171717]">{member.gender}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-[11px] font-semibold text-[#64748B] uppercase tracking-wide">JOINED SINCE</span>
          <span className="text-[13px] font-medium text-[#171717]">{member.joinedSince}</span>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-[11px] font-semibold text-[#64748B] uppercase tracking-wide">RISK STATUS</span>
         {riskStatusBadge(member.riskStatus)}
          
        </div>

        <div className="flex justify-between">
          <span className="text-[11px] font-semibold text-[#64748B] uppercase tracking-wide">LAST APPOINTMENT</span>
          <span className="text-[13px] font-medium text-[#171717]">{member.lastAppointment}</span>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-[11px] font-semibold text-[#64748B] uppercase tracking-wide">STATUS</span>
           {statusBadge(member.status)} 
        </div>
        
      </div>
      <div className="border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9] mt-3 mb-2" />
     <div className="flex items-end justify-end ">
  <button
    onClick={() => navigate(`/member-detail/${member.key}`)}
    className="flex items-center justify-center w-[26px] h-[26px] rounded-full bg-[#F1F5F9] hover:bg-[#E2E8F0] border-0 transition-colors"
  >
    <ChevronRight size={14} className="text-[#64748B]" />
  </button>
</div>

    </div>
  );

  // Columns definition for desktop
  const columns = [
    { title: "NAME", dataIndex: "name", key: "name" },
    { title: "GENDER", dataIndex: "gender", key: "gender" },
    { title: "EMAIL", dataIndex: "email", key: "email" },
    { title: "CONTACT", dataIndex: "mobile", key: "mobile" },
    { title: "JOINED SINCE", dataIndex: "joinedSince", key: "joinedSince" },
    {
      title: "RISK STATUS",
      dataIndex: "riskStatus",
      key: "riskStatus",
      render: riskStatusBadge,
    },
    {
      title: "LAST APPOINTMENT",
      dataIndex: "lastAppointment",
      key: "lastAppointment",
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      render: statusBadge,
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <button
          type="button"
          className="flex items-center justify-center w-[26px] h-[26px] rounded-full bg-[#F1F5F9] hover:bg-[#E2E8F0] border-0 transition-colors"
          onClick={() => navigate(`/member-detail/${record.key}`)}
        >
          <ChevronRight size={14} className="text-[#64748B]" />
        </button>
      ),
    },
  ];

  // Pagination Bar Component
  const PaginationBar = () => (
    <div className={`flex ${isMobile ? "flex-col pt-0 pb-3" : "flex-row py-3"} justify-between items-center px-3   gap-4 w-full `}>

      <div className="flex items-center gap-4">
        <span className={` ${isMobile ? "text-xs" : "text-sm"} text-[#64748B] font-poppins`}>Show on page</span>

     <div className="relative flex-shrink-0">
  <button
    onClick={() => setPageDropdownOpen(!pageDropdownOpen)}
    className="flex items-center gap-2 h-9 px-[12px] border-[1px] border-solid border-[#E2E8F0] bg-white rounded-xl shadow-sm text-[13px] text-[#171717] font-poppins font-semibold min-w-max hover:border-[#CBD5E1]"
  >
    {selectedPageSize} Rows
    {pageDropdownOpen ? (
      <FiChevronUp className="w-4 h-4" />
    ) : (
      <FiChevronDown className="w-4 h-4" />
    )}
  </button>

  {pageDropdownOpen && (
    <div className="absolute bottom-full mb-2 w-32 bg-white border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-md z-10 overflow-hidden">
      {pageSizeOptions.map((size) => (
        <div
          key={size}
          className="px-4 py-2 hover:bg-[#F8FAFC] cursor-pointer text-sm text-[#334155]"
          onClick={() => {
            setSelectedPageSize(size);
            setPageSize(size);
            setCurrentPage(1);
            setPageDropdownOpen(false);
          }}
        >
          {size} Rows
        </div>
      ))}
    </div>
  )}
</div>

        <span className={` ${isMobile ? "text-xs" : "text-sm"} text-[#64748B] font-poppins`}>
          Showing {(currentPage - 1) * pageSize + 1} to{" "}
          {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
          {sortedData.length} entries
        </span>
      </div>

      <Pagination
        current={currentPage}
        total={sortedData.length}
        pageSize={pageSize}
        onChange={(page) => setCurrentPage(page)}
        showSizeChanger={false}
        itemRender={(page, type, originalElement) => {
          if (type === "page") {
            return (
              <button
                className={`flex items-center justify-center h-8 px-3 rounded-lg text-sm font-semibold ${
                  page === currentPage
                    ? "bg-[#2563EB] text-white border-0"
                    : "bg-white text-[#334155] border-[1px] border-solid border-[#E2E8F0]"
                }`}
              >
                {page}
              </button>
            );
          }
          if (type === "prev") {
            return <button className="bg-white border-0 font-semibold text-sm text-[#2563EB]">Previous</button>;
          }
          if (type === "next") {
            return <button className="bg-white border-0 font-semibold text-sm text-[#2563EB]">Next</button>;
          }
          return originalElement;
        }}
      />
    </div>
  );

  return (
    <div className="px-2 font-poppins bg-white rounded-2xl overflow-y-auto">
      {/* Desktop View - Hidden on mobile */}
      <div className="hidden md:block">
        <Table
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectedRows,
            onChange: handleRowSelection,
          }}
          loading={clientMemberListLoading}
          columns={columns}
          dataSource={paginatedData}
          pagination={false}
          bordered={false}
          className="font-poppins member-table"
          rowClassName={(_, index) =>
            index % 2 === 0
              ? "bg-white transition"
              : "bg-[#F8FAFC] transition"
          }
        />
      </div>

      {/* Mobile View - Hidden on desktop */}
      <div className="block md:hidden">
        <div className="p-2">
          {paginatedData.length > 0 ? (
            paginatedData.map((member) => (
              <MemberCard key={member.key} member={member} />
            ))
          ) : (
            <div className="text-center py-8 text-[#64748B] text-sm">
              No members found
            </div>
          )}
        </div>
      </div>

      <PaginationBar />
    </div>
  );
};

export default MembersTable;